import { render } from "./ModalPopup.vue?vue&type=template&id=0852ee0f&scoped=true&ts=true"
import script from "./ModalPopup.vue?vue&type=script&lang=ts"
export * from "./ModalPopup.vue?vue&type=script&lang=ts"

import "./ModalPopup.vue?vue&type=style&index=0&id=0852ee0f&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0852ee0f"]])

export default __exports__